/** The manager's movement read on a project card (v3 §3.b.1). */
export function movementLine(input: {
  lastActivityAt: string | null;
  stepsCompletedThisWeek: number;
  completedToday: boolean;
  createdAt?: string | null;
  now?: Date;
}): { key: "moved_today" | "steps_this_week" | "quiet_days"; count?: number } | null {
  const now = input.now ?? new Date();
  const last = input.lastActivityAt ? new Date(input.lastActivityAt) : null;
  const sameDay =
    last !== null &&
    last.getFullYear() === now.getFullYear() &&
    last.getMonth() === now.getMonth() &&
    last.getDate() === now.getDate();
  if (input.completedToday || sameDay) return { key: "moved_today" };
  if (input.stepsCompletedThisWeek > 0)
    return { key: "steps_this_week", count: input.stepsCompletedThisWeek };
  let quiet = last
    ? Math.min(7, Math.max(1, Math.floor((now.getTime() - last.getTime()) / 864e5)))
    : 7;
  const created = input.createdAt ? new Date(input.createdAt) : null;
  const ageDays = created ? Math.floor((now.getTime() - created.getTime()) / 864e5) : null;
  if (ageDays !== null) {
    // Brand new project (created today) — a "quiet" read is meaningless noise.
    if (ageDays < 1) return null;
    quiet = Math.min(quiet, Math.max(1, ageDays));
  }
  return { key: "quiet_days", count: quiet };
}
